var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48116 3.75315C9.97344 3.27092 10.6411 3 11.3373 3H16.375C17.8247 3 19 4.15127 19 5.57143V18.4286C19 19.8487 17.8247 21 16.375 21H7.625C6.17525 21 5 19.8487 5 18.4286V9.20798C5 8.52599 5.27656 7.87194 5.76884 7.3897L9.48116 3.75315ZM8.14999 12C8.14999 11.574 8.50257 11.2286 8.93749 11.2286H15.0625C15.4974 11.2286 15.85 11.574 15.85 12C15.85 12.4261 15.4974 12.7715 15.0625 12.7715H8.93749C8.50257 12.7715 8.14999 12.4261 8.14999 12ZM8.93749 15.0857C8.50257 15.0857 8.14999 15.4311 8.14999 15.8572C8.14999 16.2832 8.50257 16.6286 8.93749 16.6286H15.0625C15.4974 16.6286 15.85 16.2832 15.85 15.8572C15.85 15.4311 15.4974 15.0857 15.0625 15.0857H8.93749Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoca);
export default __webpack_public_path__ + "static/media/doca.d8acfbd2042457751b504188ba243798.svg";
export { ForwardRef as ReactComponent };